import Link from "@/components/LocalizedLink";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

type IndustryCardProps = {
  code: string;
  title: string;
  description: string;
  href: string;
  ctaLabel: string;
};

const IndustryCard = ({ code, title, description, href, ctaLabel }: IndustryCardProps) => (
  <Link
    to={href}
    className="group block h-full min-w-0"
    data-event="industry_page_cta_click"
    data-event-surface="industry_card"
    data-event-target={href}
    data-event-industry-slug={href.startsWith("/industries/") ? href.split("/").filter(Boolean).slice(-1)[0] : undefined}
  >
    <div className="system-card relative h-full overflow-hidden p-6 transition-colors duration-400 group-hover:border-primary/35 group-hover:bg-primary/[0.025] md:p-7">
      <div className="absolute left-0 top-0 h-full w-px bg-primary/0 transition-colors duration-400 group-hover:bg-primary/55" aria-hidden="true" />
      <div className="mb-5 flex items-center justify-between gap-4">
        <span className="font-mono text-[10px] tracking-[0.16em] uppercase text-primary/75">{code}</span>
        <span className="flex h-8 w-8 items-center justify-center border border-border/70 bg-card shadow-[0_1px_0_hsl(var(--foreground)/0.04)] transition-colors duration-400 group-hover:border-primary/45">
          <ArrowRight className="h-3.5 w-3.5 text-muted-foreground/70 transition-all duration-400 group-hover:translate-x-0.5 group-hover:text-primary" aria-hidden="true" />
        </span>
      </div>
      <h3 className="mb-3 text-[15px] font-semibold leading-snug text-foreground">{title}</h3>
      <p className="mb-8 text-[13.5px] leading-[1.72] text-muted-foreground">{description}</p>
      <span className={cn("font-mono text-[10px] tracking-[0.12em] uppercase text-muted-foreground/78 transition-colors duration-400 group-hover:text-primary")}>
        {ctaLabel}
      </span>
    </div>
  </Link>
);

export default IndustryCard;
